export { default } from "./FormControlLabel.mjs";
export { default as formControlLabelClasses } from "./formControlLabelClasses.mjs";
export * from "./formControlLabelClasses.mjs";